// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3XTio","title":"Info_title__2qF60","links":"Info_links__2h2RG","link":"Info_link__1BtYz","logo":"Info_logo__3bYP6"};